import request from '@/sheep/request';

// 分类
export interface Square {
	id : string
	userId : number
	nickname : string
	name : string
	icon : string
	picUrl ?: string
	categoryId ?: number
	title ?: string
	description ?: string
	status ?: number
	isPublic ?: boolean
	isTimeCapsule ?: boolean
	capsuleOpenDate ?: string
	targetDate ?: string
}


// 查询关注列表
export const getSquareAttentionPage = async (params: any) => {
	return request({
		url: '/wish/square/attention/page',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

// 查询列表（故事墙）
